export interface ICallState {
    status_code: number;
    results: any;
}
export interface ICallMessageState {
    status_code: number;
    message: any;
}
export function isGetMessageSuccess(object: any) : object is ICallMessageState{
    return (
        (object.status_code === 200) && ('message' in object) 
    );
}
export function isGetSuccess(object: any) : object is ICallState{
    return (
        (object.status_code === 200) && ('results' in object) 
    );
}

export function isGetError(object:any) : object is ICallState{
    return (
        (object.status_code === 400)
    )
}

export function savePitchPromoSuccess(object: any) : object is ICallState{
    return (
        (object.status_code === 200) && ('message' in object) && object['message'] === "success"
    );
}

export function savePhotoSuccess(object: any) : object is ICallState{
    return (
        (object.status_code === 200) && ('id' in object)
    );
}

export function savePhotoError(object: any) : object is ICallState{
    return (
        (object.status_code === 400) && ('id' in object)
    );
}

export function getCarousselDestSuccess(object: any) : object is ICallState{
    return (
        (object.status_code === 200) && ('results' in object)
    );
}

export function getCarousselDestError(object: any) : object is ICallState{
    return (
        (object.status_code === 400) && ('message' in object)
    );
}